import { useMatch, useLocation } from 'react-router-dom';

import { APP_ROUTES, ROOM_ROUTE_PATTERNS } from 'routes/routePaths';

// Any single-segment app route would otherwise be matched by the broad
// '/:inviteToken' pattern. Derive the exclusion set from APP_ROUTES (the
// single source of truth) so new routes are excluded automatically.
const EXCLUDED_ROUTES = Array.from(
  new Set(
    Object.values(APP_ROUTES)
      .map((route) => `/${route.split('/')[1] ?? ''}`)
      .filter((segment) => !segment.startsWith('/:'))
  )
);

export const useIsRoomRoute = (): boolean => {
  const location = useLocation();
  const [inviteTokenPattern] = ROOM_ROUTE_PATTERNS;
  const inviteTokenMatch = useMatch(inviteTokenPattern);
  const meetingMatch = useMatch(APP_ROUTES.meeting);

  // Simple check: if path starts with /rooms or /widget/video, it's a room route (including child routes)
  if (location.pathname.startsWith('/rooms/') || location.pathname.startsWith('/widget/video/') || meetingMatch) {
    return true;
  }

  // For invite token pattern (/:inviteToken), check if it matches and isn't excluded
  if (inviteTokenMatch) {
    const isExcluded = EXCLUDED_ROUTES.some(
      (excluded) => location.pathname === excluded || location.pathname.startsWith(`${excluded}/`)
    );
    return !isExcluded;
  }

  return false;
};
